// import { roles } from "../config/roles";
import Storage from "./AsyncStorage";

export const checkRouteName = (route) => {
  // const role = localStorage.getItem("role");
  const role = Storage.getERole("@role");

  const routes = route.split("/");

  return routes[0];
};
export const isBase64 = (str) => {
  try {
    return btoa(atob(str)) === str;
  } catch (err) {
    return false;
  }
};
// export const getHeaders = () => {
//   let token = localStorage.getItem("token");
//   return {
//     headers: {
//       Accept: "application/json",
//       "Content-Type": "application/json",
//       "Content-Type": "multipart/form-data",
//       Authorization: `Bearer ${token}`,
//     },
//   };
// };

// // export const getHeaders = () => {
// //   let token = localStorage.getItem("token");
// //   return {
// //     headers: {
// //       Accept: "application/json",
// //       "Content-Type": "application/json",
// //       "Content-Type": "multipart/form-data",
// //       Authorization: `Bearer ${token}`,
// //     },
// //   };
// // };
export const headers = {
  config: () => {
    let token = Storage.getToken();

    return {
      // timeout: 5000,
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${token}`,
      },
    };
  },
};

export async function getHeaders() {
    let token = await Storage.getToken();
    return {
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    };
}

export const authHeaders = {
  config: () => {
    let token = Storage.getToken();

    return {
      // timeout: 5000,
      headers: {
        Accept: "application/json",
        "X-From-App": "web",
      },
    };
  },
};
//   configRNFetch: async () => {
//     let token = await Storage.getToken();
//     return {
//       // timeout: 5000,
//       headers: {
//         Accept: "*/*",
//         "Content-Type": "multipart/form-data",
//         Authorization: `Bearer ${token}`,
//       },
//     };
//   },
// };

// export const GlobalDebug = (function () {
//   var savedConsole = console;
//   /**
//    * @param {boolean} debugOn
//    * @param {boolean} suppressAll
//    */
//   return function (debugOn, suppressAll) {
//     var suppress = suppressAll || false;
//     if (debugOn === false) {
//       // supress the default console functionality
//       // console = {};
//       console.log = function () {};
//       // supress all type of consoles
//       if (suppress) {
//         console.info = function () {};
//         console.warn = function () {};
//         console.error = function () {};
//       } else {
//         console.info = savedConsole.info;
//         console.warn = savedConsole.warn;
//         console.error = savedConsole.error;
//       }
//     } else {
//       console = savedConsole;
//     }
//   };
// })();
export const phoneFormat = (text) => {
  var cleaned = ("" + text).replace(/\D/g, "");
  var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);

  if (match) {
    var intlCode = match[1] ? "+1 " : "",
      number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
        ""
      );
    return number;
  }
  return text;
};
export const extractBytes = (hexString) => {
  // Ensure hex string has even length
  if (hexString.length % 2 !== 0) {
    throw new Error("Invalid hex string");
  }
  // Split hex string into array of bytes
  const bytes = hexString.match(/.{1,2}/g); // Each byte = 2 hex characters
  // Get last 2 bytes and reverse them
  const lastTwoReversed = [bytes[bytes.length - 1], bytes[bytes.length - 2]];
  return lastTwoReversed.join("");
};
export const hexToBase64 = (hex) => {
  const bytes = hex.match(/.{1,2}/g).map((byte) => parseInt(byte, 16));
  const binary = String.fromCharCode(...bytes);
  return btoa(binary); // Works in browsers and RN >= 0.70+
};

export const inputHandler = (e) => {
  const { value, maxLength } = e.target;
  if (String(value).length >= maxLength) {
    e.preventDefault();
    return;
  }
};
